module.exports = __webpack_public_path__ + "img/00040.22d6dde2.webp";